import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Message } from '@qtek/shared/models';
import {
  catchError,
  concatMap,
  from,
  map,
  Observable,
  of,
  switchMap,
} from 'rxjs';

import { UserActions } from '../user';
import { CompanyService } from './company.service';
import { PersonService } from './person.service';
import { WizardActions } from './wizard.actions';
import { WizardService } from './wizard.service';

@Injectable()
export class WizardEffects {
  wizard$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(WizardActions.getSteps),
      switchMap(() =>
        this.wizardService.getSteps().pipe(
          concatMap(({ res }) => {
            return from([
              WizardActions.setMaxPersonProgress({
                payload: res.meta.progress[0].value,
              }),
              WizardActions.setMaxCompanyProgress({
                payload: res.meta.progress[1] ? res.meta.progress[1].value : 0,
              }),
              WizardActions.getStepsSuccess({ payload: res.children }),
            ]);
          })
        )
      )
    )
  );

  prs1$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WizardActions.stepPrs1),
      switchMap(({ payload }) =>
        this.personService.updatePerson(payload.form, payload.additionalPayload)
      ),
      map(({ res }) =>
        UserActions.updateCurrentUserSuccess({
          payload: res,
          message: new Message('GNR_PRS_INFO_SAVED'),
        })
      ),
      catchError(({ sts }) =>
        of(UserActions.updateCurrentUserFailure({ payload: sts }))
      )
    )
  );

  prs2$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WizardActions.stepPrs2),
      switchMap(({ payload }) =>
        this.personService.updatePerson(payload.form, payload.additionalPayload)
      ),
      map(({ res }) =>
        UserActions.updateCurrentUserSuccess({
          payload: res,
          message: new Message('GNR_PRS_INFO_SAVED'),
        })
      ),
      catchError(({ sts }) =>
        of(UserActions.updateCurrentUserFailure({ payload: sts }))
      )
    )
  );

  cmp2048$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(WizardActions.stepCmp2048),
      switchMap(({ payload }) =>
        this.companyService.updateCompany(
          payload.additionalPayload,
          payload.form
        )
      ),
      map(({ res }) =>
        UserActions.updateCurrentUserCompanySuccess({
          payload: res,
          message: new Message('GNR_CMP_INFO_SAVED'),
          skipReload: true,
        })
      ),
      catchError(({ sts }) =>
        of(UserActions.updateCurrentUserCompanyFailure({ payload: sts }))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private wizardService: WizardService,
    private personService: PersonService,
    private companyService: CompanyService
  ) {}
}
